import { render } from "./PaymentRedirectView.vue?vue&type=template&id=0c6c5257&scoped=true"
import script from "./PaymentRedirectView.vue?vue&type=script&lang=js"
export * from "./PaymentRedirectView.vue?vue&type=script&lang=js"

import "./PaymentRedirectView.vue?vue&type=style&index=0&id=0c6c5257&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c6c5257"]])

export default __exports__